<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getEventLabelTitleErrorMessage } from './validations';
import { useVuelidate } from '@vuelidate/core';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    selectedResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      title: '',
      color: '',
      description: '',
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'planningEventLabels/getUIFlags',
    }),
    pageTitle() {
      return `${this.$t('EVENT_LABEL_MGMT.EDIT.TITLE')} - ${
        this.selectedResponse.title
      }`;
    },
    labelTitleErrorMessage() {
      const errorMessage = getEventLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    setFormValues() {
      this.title = this.selectedResponse.title;
      this.color = this.selectedResponse.color;
      this.description = this.selectedResponse.description || '';
    },
    async editEventLabel() {
      try {
        await this.$store.dispatch('planningEventLabels/update', {
          id: this.selectedResponse.id,
          color: this.color,
          title: this.title.toLowerCase(),
          description: this.description,
        });
        useAlert(this.$t('EVENT_LABEL_MGMT.EDIT.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        useAlert(this.$t('EVENT_LABEL_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="pageTitle" />
    <form class="flex flex-wrap mx-0" @submit.prevent="editEventLabel">
      <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('EVENT_LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('EVENT_LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      />

      <label class="w-full">
        {{ $t('EVENT_LABEL_MGMT.FORM.DESCRIPTION.LABEL') }}
        <textarea
          v-model="description"
          rows="3"
          :placeholder="$t('EVENT_LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        />
      </label>

      <div class="w-full">
        <label>
          {{ $t('EVENT_LABEL_MGMT.FORM.COLOR.LABEL') }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('EVENT_LABEL_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="$t('EVENT_LABEL_MGMT.FORM.EDIT')"
          :disabled="v$.title.$invalid || uiFlags.isUpdating"
          :is-loading="uiFlags.isUpdating"
        />
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
// Event label API supports only lowercase letters
.label-name--input {
  ::v-deep {
    input {
      @apply lowercase;
    }
  }
}
</style>
